import React, { Component } from 'react'
import Room from 'material-ui/svg-icons/action/group-work'
import ScreenShare from 'material-ui/svg-icons/communication/screen-share'
import Settings from 'material-ui/svg-icons/action/settings'
import Help from 'material-ui/svg-icons/action/help-outline'
import ChatIcon from 'material-ui/svg-icons/action/question-answer'
import Video from 'material-ui/svg-icons/av/videocam'
import Drawer from 'material-ui/Drawer'
import VideoOff from 'material-ui/svg-icons/av/videocam-off'
import Mic from 'material-ui/svg-icons/av/mic'
import MicOff from 'material-ui/svg-icons/av/mic-off'
import Phone from 'material-ui/svg-icons/maps/local-phone'
import IconButton from 'material-ui/IconButton'
import Clear from 'material-ui/svg-icons/content/clear'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import SeminarTabs from '../../components/SeminarTabs'
import Timer from '../../components/Timer'
import { checkJapanese, checkMobile, detectmob, isSentryBreadcrumbs } from '../../lib/lib'
import ReactTooltip from 'react-tooltip'
import enhanceWithClickOutside from 'react-click-outside'

class FloatingButtons extends Component {
  constructor (props) {
    super(props)

    this.state = {
      helpClicked: false,
      videoClicked: props.muteVideo,
      micClicked: false,
      shareClicked: false
    }
    this.window = null
  }

  componentDidMount () {
    this.window = window.open('', '_self')
  }

  handleToggle = () => {
    try {
      this.props.notify_count_reset()
      this.props.handleOpenDrawer()
    }
    catch (error) {
      const message = 'chat handleToggle() failed'
      isSentryBreadcrumbs(error, message)
    }
  }

  handleClose = () => {
    try {
      this.props.notify_count_reset()
      this.props.handleCloseDrawer()
    }
    catch (error) {
      const message = 'chat handleClose() failed'
      isSentryBreadcrumbs(error, message)
    }
  }

  render () {
    return (
      <div>
        <div className='flex justify-between items-center h-100 w-100 flex-column-xs floatButton'>
          <Timer isBreakout={(this.props.mode == 'breakout')}/>
          {this.props.buttonDisplay && <div className="videoCall" style={checkMobile() ? {} : {
            position: 'absolute',
            height: '8vh',
            bottom: '5vh',
            zIndex: 150,
            left: '50%',
            transform: 'translateX(-50%)'
          }}>
            {!this.props.mobile && this.props.mode == 'seminar' && this.props.role == 'teacher' &&
            <div style={{display: 'inline-block', marginRight: '.5rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `ディスカッションモードへ` : `
                    Go to Breakout Mode
                  `}
                </div>`}
                onClick={(e) => this.props.handleListClick(e, 'breakout')}
                backgroundColor='#29B87A'
                className='ml6 mr3 float-flat-button'
                style={{width: 100, borderRadius: '40px'}}>
                <Room/>
              </FloatingActionButton></div>}
            {this.props.mode == 'breakout' && this.props.break_join &&
            <div className="videoAttr" style={{display: 'inline-block', marginRight: '.7rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    中央へ戻る
                    ` : `
                    Go Back to Main Room
                  `}
                </div>`}
                backgroundColor={'#00bcd4'}
                onClick={(e) => this.props.joinVideo(this.props.user_uid, this.props.user_name, 0, this.props.user_id, this.props.role, this.props.direct)}
                iconStyle={{fill: '#FFFFFF'}}
              >
                <Room/>
              </FloatingActionButton></div>}
            {(this.props.publish_state_default && !detectmob()) &&
            <div style={{display: 'inline-block', marginRight: '.7rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html
              />
              <FloatingActionButton
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    画面共有
                    ` : `
                    Screen Share
                  `}
                </div>`}
                backgroundColor={(this.props.screen_publish_state) ? '#FFFFFF' : '#00bcd4'}
                onClick={(e) => this.props.handleListClick(e, 'share')}
                iconStyle={{fill: (this.props.screen_publish_state) ? '#AFB9C5' : '#FFFFFF'}}
              >
                <ScreenShare/>
              </FloatingActionButton></div>}

            {this.props.mode == 'seminar' && this.props.role != 'teacher' &&
            <div style={{display: 'inline-block', marginRight: '.5rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    発言申請をする
                    ` : `
                    Ask Question
                  `}
                </div>`}
                backgroundColor={(this.props.raise) ? '#FFFFFF' : '#00bcd4'}
                onClick={(e) => this.props.handleListClick(e, 'raise')}
                iconStyle={{fill: (this.props.raise) ? '#AFB9C5' : '#FFFFFF'}}
              >
                <Help/>
              </FloatingActionButton></div>}
            {(this.props.publish_state_default) &&
            <div className="videoAttr" style={{display: 'inline-block', marginRight: '.7rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                className="btnSmallMobile"
                data-tip={!detectmob() ? `
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    デバイスの設定
                    ` : `
                    Device Setting
                  `}
                </div>` : ''}
                backgroundColor={(this.props.isSetting) ? '#FFFFFF' : '#00bcd4'}
                onClick={(e) => this.props.handleListClick(e, 'settings')}
                iconStyle={{fill: (this.props.isSetting) ? '#00bcd4' : '#FFFFFF'}}
              >
                <Settings/>
              </FloatingActionButton></div>}
            {(this.props.publish_state_default) &&
            <div className="videoAttr" style={{display: 'inline-block', marginRight: '.7rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                className="btnSmallMobile"
                data-tip={!detectmob() ?
                  `<div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    映像のミュート
                    ` : `
                    Mute Video ON/OFF
                  `}
                </div>` : ''}
                backgroundColor={(this.props.muteVideo) ? '#FFFFFF' : '#00bcd4'}
                onClick={(e) => this.props.handleListClick(e, 'video')}
                iconStyle={{fill: (this.props.muteVideo) ? '#AFB9C5' : '#FFFFFF'}}
              >
                {(this.props.muteVideo) ? <VideoOff/> : <Video/>}
              </FloatingActionButton></div>}
            {(this.props.publish_state_default) &&
            <div className="videoAttr" style={{display: 'inline-block', marginRight: '.7rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                className="btnSmallMobile"
                data-tip={!detectmob() ? `
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    音声のミュート
                    ` : `
                    Mute Audio ON/OFF
                  `}
                </div>` : ''}
                backgroundColor={(this.props.muteAudio) ? '#FFFFFF' : '#00bcd4'}
                onClick={(e) => this.props.handleListClick(e, 'mic')}
                iconStyle={{fill: (this.props.muteAudio) ? '#AFB9C5' : '#FFFFFF'}}
              >
                {(this.props.muteAudio) ? <MicOff/> : <Mic/>}
              </FloatingActionButton>
            </div>}
            <div className="videoEnd" style={{display: 'inline-block', marginRight: '.7rem'}}>
              <ReactTooltip
                place='top'
                multiline
                effect='solid'
                html/>
              <FloatingActionButton
                data-tip={!detectmob() ? `
                  <div
                    class='pb2 custom-tooltip btnVideo'>
                    ${(checkJapanese()) ? `セミナーの終了` : `End Seminar`}
                  </div>` : ''}
                backgroundColor={'#F01631'}
                onClick={(e) => {
                  if (this.props.role == 'teacher' && this.props.mode == 'seminar') {
                    this.props.handleListClick(e, 'end')
                  } else {
                    if (window.confirm('本当に退出しますか?')) {
                      window.location = '/'
                      return
                    }
                  }
                }}
                className='ml3 mr3 float-flat-button'
                style={{width: 100, borderRadius: '40px'}}>
                <Phone style={{transform: 'rotate(134deg)'}}/>
              </FloatingActionButton>
            </div>
          </div>}
          <div className='mr1 chatBoxMobile' style={checkMobile() ? {} : {
            height: '8vh',
            position: 'absolute',
            bottom: '5vh',
            zIndex: 150,
            right: '0px'
          }}>
            {!this.props.isOpenDrawer && this.props.notify_count != 0 ? <a id="mark" style={{
              color: 'white',
              position: 'relative'
            }}>
              <span style={{right: '30px', width: '18px'}}
                    className="ft_pop ft_m ft_wg messageCount">{this.props.notify_count}</span>
            </a> : <a id="dummy">
              <span style={{right: '30px'}}></span>
            </a>}
            <FloatingActionButton
              aria-label="vfgfd"
              className="btnSmallMobile"
              data-tip={!detectmob() ? `
              <div
                class='pb2 custom-tooltip btnVideo'>
                ${(checkJapanese()) ? `
                チャット
                  ` : `
                  Chat
                `}
              </div>` : ''}
              onClick={this.handleToggle}
              iconStyle={{fill: '#FFFFFF'}}
              backgroundColor={'#46CE90'}>
              <ChatIcon/>
            </FloatingActionButton>
          </div>
        </div>

        <Drawer
          className="drawerChat"
          containerStyle={{overflow: 'hidden'}}
          openSecondary
          width='100%'
          open={this.props.isOpenDrawer}
        >
          <div
            className='flex justify-end pa3 items-center chat-header'
            style={{
              height: '9vh',
              backgroundColor: '#4688f1',
            }}>
            <IconButton
              onClick={this.handleClose}
              iconStyle={{fill: '#FFFFFF'}}>
              <Clear className="clear-style"/>
            </IconButton>
          </div>
          <div>
            <SeminarTabs location={this.props.location} mode={this.props.mode}
                         break_join={this.props.break_join} remoteList={this.props.remoteList}
                         raiseList={this.props.raiseList} handleListClick={this.props.handleListClick}
                         handleChat={this.props.handleChat} user_name={this.props.user_name} chat={this.props.chat}
                         groupList={this.props.groupList} group={this.props.group}
                         groupListObj={this.props.groupListObj}/>
          </div>
        </Drawer>
      </div>
    )
  }
}

export default enhanceWithClickOutside(FloatingButtons)



// WEBPACK FOOTER //
// ./src/routes/SeminarMode/FloatingButtons.js